export enum VatDeclarationsTableAccessor {
  Description = 'description',
  Status = 'status',
  PeriodName = 'periodName',
  Result = 'result',
}
